module.exports = __webpack_public_path__ + "img/logo_customeasy_oriz_white.616d8486.png";